var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["ReadableStream"]: () => __WEBPACK_EXTERNAL_MODULE_web_streams_polyfill_c4c9f3ad__.ReadableStream });